import React, { useState } from "react";
import BookConsultModal from "../BookConsultModal";
import wp1 from '../../assets/basement8.jpg';
import basement2 from '../../assets/basement9.jpeg';
import basement3 from '../../assets/basement5.jpg';
import basement6 from '../../assets/basement6.jpg';
import basement7 from "../../assets/basement7.jpg";
import { Droplets, Shield, Hammer, Home } from "lucide-react";

const BasementUnique = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="bg-[#fefcf8]">

      {/* HERO SECTION - KEEP AS IS */}
     <section className="relative h-[90vh] flex items-center justify-center">
  <img src={wp1} className="absolute inset-0 w-full h-full object-cover" />
  <div className="absolute inset-0 bg-black/40"></div>

  <div className="relative z-10 max-w-3xl text-center bg-white/10 backdrop-blur-lg rounded-3xl p-12 shadow-2xl">
    <h1 className="text-5xl font-serif font-bold text-white mb-6 drop-shadow-lg">
      Say Goodbye to Basement Dampness
    </h1>
    <p className="text-lg text-white mb-8 drop-shadow-md">
      Protect your basement from water seepage, mold, and structural damage with our expert waterproofing solutions.
    </p>
    <button className="bg-amber-600 hover:bg-amber-700 text-white px-10 py-4 rounded-full font-semibold shadow-xl transition">
      Book Free Inspection
    </button>
  </div>
</section>


      {/* NEW SECTION: PREMIUM FEATURES */}
      <section className="py-28 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-700 mb-4">Why Choose Our Waterproofing?</h2>
          <p className="text-gray-700 mb-12 text-lg">
            Advanced solutions, expert execution, and long-lasting protection for your basement.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
            {[ 
              { icon: <Droplets size={28} />, title: "Leakproof", desc: "Prevent water seepage effectively." },
              { icon: <Shield size={28} />, title: "Durable", desc: "Long-lasting protection for your home." },
              { icon: <Hammer size={28} />, title: "Expert Team", desc: "Skilled professionals ensure perfect results." },
              { icon: <Home size={28} />, title: "Healthy Spaces", desc: "Mold-free, safe basements for your family." },
            ].map((item, i) => (
              <div key={i} className="bg-white p-10 rounded-3xl shadow-xl hover:shadow-2xl transition hover:-translate-y-3 text-center">
                <div className="w-16 h-16 mx-auto mb-5 rounded-xl bg-amber-600 flex items-center justify-center text-white text-2xl">
                  {item.icon}
                </div>
                <h3 className="font-semibold text-xl mb-2">{item.title}</h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* PROBLEM & SOLUTION */}
<section className="py-28 bg-[#fefcf8]">
  <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
    
    <div>
      <h2 className="text-4xl md:text-5xl font-bold text-amber-700 mb-6">
        The Hidden Problem in Most Basements
      </h2>
      <p className="text-gray-700 mb-6 leading-relaxed">
        Most homeowners ignore early signs of basement leakage like 
        damp smell, wall stains and minor cracks. Over time, this leads 
        to serious structural damage, mold growth and unhealthy living conditions.
      </p>
      <ul className="space-y-3 text-gray-700">
        <li>❌ Weak foundation</li>
        <li>❌ Fungus & mold</li>
        <li>❌ Bad air quality</li>
        <li>❌ Reduced property value</li>
      </ul>
    </div>

    <div>
      <h3 className="text-2xl font-semibold text-gray-800 mb-4">
        Our Professional Solution
      </h3>
      <p className="text-gray-700 mb-6 leading-relaxed">
        We use advanced chemical waterproofing systems 
        that penetrate deep into walls and slabs, 
        forming an invisible protective barrier.
      </p>
      <ul className="space-y-3 text-gray-700">
        <li>✔ Non-invasive treatment</li>
        <li>✔ Long-lasting protection</li>
        <li>✔ Eco-friendly chemicals</li>
        <li>✔ 10+ years durability</li>
      </ul>
    </div>

  </div>
</section>


      {/* NEW SECTION: GALLERY WITH STAGGERED LAYOUT */}
      <section className="py-28">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-700 text-center mb-12">Before & After Transformations</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="rounded-3xl overflow-hidden shadow-lg relative">
              <img src={basement7} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
              
            </div>
            <div className="rounded-3xl overflow-hidden shadow-lg relative">
              <img src={basement3} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
              
            </div>
            <div className="rounded-3xl overflow-hidden shadow-lg relative">
              <img src={basement6} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
              
            </div>
          </div>
        </div>
      </section>

      {/* NEW SECTION: PROCESS WITH ICONS */}
      <section className="py-28 bg-white">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-700 mb-8">Our Waterproofing Process</h2>
          <p className="text-gray-700 mb-16 text-lg max-w-2xl mx-auto">
            Step by step, we ensure your basement remains dry, safe, and mold-free.
          </p>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: "Inspection", desc: "Assess leaks and damp areas", icon: "🔍" },
              { step: "Preparation", desc: "Clean & seal cracks", icon: "🧹" },
              { step: "Waterproof", desc: "Apply protective coating", icon: "🧪" },
              { step: "Verification", desc: "Test for full water resistance", icon: "✅" }
            ].map((item, i) => (
              <div key={i} className="bg-amber-50 p-8 rounded-3xl shadow-lg hover:shadow-2xl transition hover:-translate-y-2 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-lg bg-amber-600 flex items-center justify-center text-white text-xl">{item.icon}</div>
                <h3 className="font-semibold text-lg mb-2">{item.step}</h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
<section className="py-28 bg-[#fefcf8]">
  <div className="max-w-5xl mx-auto px-6">
    <h2 className="text-4xl md:text-5xl font-bold text-amber-700 text-center mb-16">
      Frequently Asked Questions
    </h2>

    <div className="space-y-8">
      {[
        {
          q: "How long does basement waterproofing last?",
          a: "Our treatment lasts 8–12 years depending on conditions and maintenance."
        },
        {
          q: "Will I need to vacate my home?",
          a: "No. The process is non-invasive and safe for daily living."
        },
        {
          q: "How much time does the process take?",
          a: "Usually 2–3 days for a standard basement."
        },
        {
          q: "Is it safe for kids and pets?",
          a: "Yes. We use eco-friendly and non-toxic chemicals."
        },
      ].map((item, i) => (
        <div key={i} className="bg-white p-8 rounded-2xl shadow-md">
          <h3 className="font-semibold text-lg mb-2">
            {item.q}
          </h3>
          <p className="text-gray-600">
            {item.a}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* NEW PREMIUM CTA */}
      <section className="py-32 bg-gradient-to-r from-amber-100 to-amber-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="bg-white/90 backdrop-blur-xl border border-amber-300 rounded-[3rem] p-16 shadow-lg hover:scale-105 transition-transform">
            <span className="inline-block mb-4 px-5 py-1 rounded-full bg-amber-100 text-amber-700 text-sm tracking-wide">Free Basement Consultation</span>
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-800">
              Secure Your Basement <span className="text-amber-600">Today</span>
            </h2>
            <p className="text-gray-600 max-w-xl mx-auto mb-10 text-lg leading-relaxed">
              Prevent structural damage and mold. Book your free inspection and get peace of mind.
            </p>
            <div className="flex justify-center gap-4">
              <button
                onClick={() => setIsModalOpen(true)}
                className="px-10 py-4 bg-gradient-to-r from-amber-600 to-amber-800 text-white rounded-full font-semibold shadow-lg hover:scale-105 transition"
              >
                Book Free Inspection
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                className="px-10 py-4 border border-amber-700 text-amber-700 rounded-full hover:bg-amber-50 transition"
              >
                Talk to Expert
              </button>
            </div>
          </div>
        </div>
      </section>

      <BookConsultModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default BasementUnique;
